(function () {
  "use strict";
  var SECCAO = "sar-gaveta", gaveta, veu, relogio = null;
  var CHAVE_CRON = "sarCronDesde";

  function montar() {
    veu = document.querySelector(".sar-veu");
    gaveta = document.querySelector(".sar-gaveta");
    return !!(gaveta && veu);
  }

  /* ---------- moeda ----------
     Limiares em centimos da moeda BASE (GBP). Shopify.currency.rate e o
     multiplicador base -> moeda apresentada. cart.total_price ja vem na
     moeda apresentada, por isso convertemos os limiares para o mesmo espaco. */
  function taxa() {
    try {
      var r = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate);
      return (isFinite(r) && r > 0) ? r : 1;
    } catch (e) { return 1; }
  }
  /* ,90 seguinte (em centimos) >= c: 10772 -> 10790 */
  function cima90(c) { return c > 0 ? Math.ceil((c - 90) / 100) * 100 + 90 : 0; }
  /* "USD=10990/14990;CAD=15990/21990" -> [10990,14990] para a moeda ativa */
  function limiaresLocais(txt) {
    var m = moedaAtiva(), res = [0, 0];
    (txt || "").split(";").forEach(function (par) {
      var p = par.split("=");
      if (p.length === 2 && p[0].trim().toUpperCase() === m) {
        var v = p[1].split("/");
        res = [parseInt(v[0], 10) || 0, parseInt(v[1], 10) || 0];
      }
    });
    return res;
  }
  function moedaAtiva() {
    try { return (window.Shopify && Shopify.currency && Shopify.currency.active) || "GBP"; }
    catch (e) { return "GBP"; }
  }
  function dinheiro(centimos) {
    var v = centimos / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en", {
        style: "currency", currency: moedaAtiva(),
        minimumFractionDigits: 2, maximumFractionDigits: 2
      }).format(v);
    } catch (e) { return v.toFixed(2); }
  }

  /* ---------- cronometro ---------- */
  function cronometro() {
    if (relogio) { clearInterval(relogio); relogio = null; }
    var caixa = gaveta.querySelector("[data-sar-cron]");
    var alvo = gaveta.querySelector("[data-sar-cron-n]");
    if (!caixa || !alvo) return;

    var minutos = parseInt(gaveta.getAttribute("data-minutos"), 10);
    if (!minutos || minutos < 1) minutos = 10;
    var total = minutos * 60;

    var desde;
    try { desde = parseInt(sessionStorage.getItem(CHAVE_CRON), 10); } catch (e) { desde = null; }
    if (!desde || isNaN(desde)) {
      desde = Date.now();
      try { sessionStorage.setItem(CHAVE_CRON, String(desde)); } catch (e) {}
    }
    function tique() {
      var resta = total - Math.floor((Date.now() - desde) / 1000);
      if (resta <= 0) {
        desde = Date.now();
        try { sessionStorage.setItem(CHAVE_CRON, String(desde)); } catch (e) {}
        resta = total;
      }
      var mm = Math.floor(resta / 60), ss = resta % 60;
      alvo.textContent = (mm < 10 ? "0" : "") + mm + ":" + (ss < 10 ? "0" : "") + ss;
    }
    tique();
    relogio = setInterval(tique, 1000);
  }

  /* ---------- barra frio -> quente + faixa de ganho ---------- */
  function pintar() {
    var barra = gaveta.querySelector("[data-sar-barra]");
    var t = taxa();
    /* r1/r2: limiar REAL na moeda do cliente (GBP x taxa), o que a Shopify usa no desconto.
       l1/l2: valor MOSTRADO, redondo na moeda local (definicao "limiares_moedas"), nunca abaixo do real. */
    var r1 = Math.round(parseInt(gaveta.getAttribute("data-l1"), 10) * t);
    var r2 = Math.round(parseInt(gaveta.getAttribute("data-l2"), 10) * t);
    var mostrar = moedaAtiva() === "GBP" ? [0, 0] : limiaresLocais(gaveta.getAttribute("data-lm"));
    var l1 = moedaAtiva() === "GBP" ? r1 : Math.max(mostrar[0] || 0, cima90(r1));
    var l2 = moedaAtiva() === "GBP" ? r2 : Math.max(mostrar[1] || 0, cima90(r2));
    var p1 = parseInt(gaveta.getAttribute("data-p1"), 10);
    var p2 = parseInt(gaveta.getAttribute("data-p2"), 10);
    var base = parseInt(gaveta.getAttribute("data-base"), 10) || 0;
    if (!l1 || !l2 || l2 <= l1) return;

    if (barra) {
      var pct = Math.max(0, Math.min(100, (base / l2) * 100));
      var posM1 = (l1 / l2) * 100;

      var fio = barra.querySelector("[data-sar-fio]");
      if (fio) {
        fio.style.width = pct + "%";
        /* O gradiente representa sempre a calha inteira: a medida que o
           preenchimento cresce, vao-se revelando as cores quentes. */
        fio.style.backgroundSize = (pct > 0 ? (10000 / pct) : 100) + "% 100%";
      }
      var m1 = barra.querySelector("[data-sar-marca1]");
      if (m1) { m1.style.left = posM1 + "%"; m1.classList.toggle("atingida", base >= r1); }
      var m2 = barra.querySelector("[data-sar-marca2]");
      if (m2) m2.classList.toggle("atingida", base >= r2);
      var d1 = barra.querySelector("[data-sar-deg1]");
      if (d1) { d1.style.left = posM1 + "%"; d1.classList.toggle("atingido", base >= r1); }
      var d2 = barra.querySelector("[data-sar-deg2]");
      if (d2) d2.classList.toggle("atingido", base >= r2);
      var v1 = barra.querySelector("[data-sar-v1]"); if (v1) v1.textContent = dinheiro(l1);
      var v2 = barra.querySelector("[data-sar-v2]"); if (v2) v2.textContent = dinheiro(l2);

      var frase = barra.querySelector("[data-sar-frase]");
      var ico = barra.querySelector("[data-sar-ico]");
      var ganho = false, txt = "", emoji = "❄️";
      if (base >= r2) {
        ganho = true; emoji = "🔥";
        txt = "Maximum discount unlocked — <b>" + p2 + "% off</b>";
      } else if (base >= r1) {
        ganho = true; emoji = "⚡";
        txt = "<b>" + p1 + "% off</b> unlocked. Add <b>" + dinheiro(l2 - base) + "</b> for " + p2 + "%";
      } else {
        emoji = pct > 50 ? "🌡️" : "❄️";
        txt = "Add <b>" + dinheiro(l1 - base) + "</b> to unlock <b>" + p1 + "% off</b>";
      }
      if (frase) frase.innerHTML = txt;
      if (ico) ico.textContent = emoji;
      barra.classList.toggle("sar-barra--ganho", ganho);
    }

    /* A faixa de desconto e o total sao renderizados em Liquid
       com os valores REAIS da Shopify (cart.cart_level_discount_applications
       e cart.total_price). O JS nao os recalcula, para nunca mostrar
       um total diferente do que o cliente paga no checkout. */
  }

  /* ---------- rede ---------- */
  function pedir(url) {
    return fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } })
      .then(function (r) { return r.ok ? r.text() : ""; });
  }
  function desembrulhar(html) {
    var caixa = document.createElement("div");
    caixa.innerHTML = html;
    var dentro = caixa.querySelector('[id^="shopify-section-"]');
    return dentro ? dentro.innerHTML : caixa.innerHTML;
  }
  function redesenhar() {
    return pedir("?sections=" + SECCAO).then(function (txt) {
      if (!txt) return;
      var j; try { j = JSON.parse(txt); } catch (e) { return; }
      if (!j[SECCAO]) return;
      var novo = document.createElement("div");
      novo.innerHTML = desembrulhar(j[SECCAO]);
      var nGaveta = novo.querySelector(".sar-gaveta");
      if (!nGaveta) return;
      var estavaAberta = gaveta.classList.contains("aberta");
      /* O seletor de variantes vive dentro da gaveta, por isso desaparece
         aqui. Guardar o produto e as opcoes ja escolhidas para o repor. */
      var pickerGuardado = pickerAberto;
      var selGuardada = escolhido ? escolhido.sel.slice() : null;
      gaveta.innerHTML = nGaveta.innerHTML;
      ["data-l1","data-l2","data-lm","data-p1","data-p2","data-base","data-total","data-minutos"].forEach(function (a) {
        var v = nGaveta.getAttribute(a);
        if (v !== null) gaveta.setAttribute(a, v);
      });
      if (estavaAberta) gaveta.classList.add("aberta");
      escolhido = null;
      contaNoCabecalho();
      pintar();
      cronometro();
      if (pickerGuardado) abrirPicker(pickerGuardado, null, selGuardada);
    });
  }
  function contaNoCabecalho() {
    var n = gaveta.querySelector(".sar-gaveta__conta");
    if (!n) return;
    var q = n.textContent.trim();
    document.querySelectorAll(".cart-count-bubble span:first-child, [data-cart-count], .cart-count").forEach(function (e) {
      e.textContent = q;
    });
  }

  /* ---------- abrir / fechar ---------- */
  function abrir() {
    if (!gaveta && !montar()) return;
    veu.classList.add("aberta");
    gaveta.classList.add("aberta");
    document.documentElement.style.overflow = "hidden";
    var f = gaveta.querySelector(".sar-gaveta__fechar");
    if (f) f.focus({ preventScroll: true });
  }
  function fechar() {
    if (!gaveta) return;
    veu.classList.remove("aberta");
    gaveta.classList.remove("aberta");
    document.documentElement.style.overflow = "";
    fecharPicker();
  }

  /* ---------- accoes ---------- */
  function mudar(chave, quantidade) {
    gaveta.classList.add("a-trabalhar");
    return fetch("/cart/change.js", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: chave, quantity: quantidade })
    }).then(redesenhar).finally(function () { gaveta.classList.remove("a-trabalhar"); });
  }
  function juntar(idVariante, botao) {
    if (botao) botao.disabled = true;
    gaveta.classList.add("a-trabalhar");
    return fetch("/cart/add.js", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: Number(idVariante), quantity: 1 })
    }).then(redesenhar).finally(function () { gaveta.classList.remove("a-trabalhar"); });
  }
  function seguro(caixa) {
    var idVariante = caixa.getAttribute("data-sar-seguro");
    var chave = caixa.getAttribute("data-sar-seguro-chave");
    caixa.disabled = true;
    var p = caixa.checked
      ? fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: Number(idVariante), quantity: 1 }) })
      : fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: chave, quantity: 0 }) });
    return p.then(redesenhar).catch(function () { caixa.disabled = false; });
  }

  /* ---------- seletor de variantes para as sugestoes ----------
     Produtos com 60-320 variantes (Cor x Marca do carro). Adicionar
     a primeira variante enviaria o emblema errado, por isso abre-se
     um painel e carrega-se /products/<handle>.js a pedido.          */
  var prodCache = {}, escolhido = null;
  /* Handle do produto cujo seletor esta aberto, guardado a parte de
     "escolhido" porque redesenhar() substitui a gaveta inteira. As apps da
     loja fazem POST /cart/update.js ao carregar a pagina (duas vezes, aos
     ~480ms); cada uma disparava um redesenhar() que apagava o seletor que o
     link do email tinha acabado de abrir - dai a gaveta aparecer vazia. */
  var pickerAberto = null;

  /* Algumas opcoes ja se chamam "Choose your set"; nao lhes voltar a por
     "Choose" a frente. */
  function pedido(nome) {
    return /^choose/i.test(nome) ? nome : ("Choose " + nome.toLowerCase());
  }

  function abrirPicker(handle, botao, selAnterior) {
    var painel = gaveta.querySelector("[data-sar-picker]");
    if (!painel) return;
    pickerAberto = handle;
    if (botao) botao.disabled = true;
    var p = prodCache[handle]
      ? Promise.resolve(prodCache[handle])
      : fetch("/products/" + handle + ".js").then(function (r) { return r.json(); })
          .then(function (j) { prodCache[handle] = j; return j; });
    return p.then(function (prod) {
      /* Re-procurar o painel: entre o pedido e a resposta pode ter havido um
         redesenhar() (uma app da loja escreve atributos do carrinho ao
         carregar a pagina) e o painel capturado acima ficaria orfao. */
      painel = gaveta.querySelector("[data-sar-picker]");
      if (!painel) return;
      escolhido = { prod: prod, opcoes: prod.options.map(function (o) {
        return (typeof o === "string") ? o : o.name; }), sel: [] };
      painel.querySelector("[data-sar-picker-nome]").textContent = prod.title;
      var foto = painel.querySelector("[data-sar-picker-foto]");
      var imgUrl = prod.featured_image || (prod.images && prod.images[0]);
      if (foto) {
        if (imgUrl) { foto.src = imgUrl + (imgUrl.indexOf("?") === -1 ? "?" : "&") + "width=200"; foto.alt = prod.title; }
        else foto.removeAttribute("src");
      }
      precoPicker(painel, prod.price, prod.compare_at_price);
      var caixa = painel.querySelector("[data-sar-picker-opcoes]");
      caixa.innerHTML = escolhido.opcoes.map(function (nome, i) {
        var vals = [];
        prod.variants.forEach(function (v) {
          var val = v.options[i];
          if (val && vals.indexOf(val) === -1) vals.push(val);
        });
        return "<label class=\"sar-picker__campo\"><span>" + nome + "</span>" +
          "<select data-sar-opt=\"" + i + "\">" +
          "<option value=\"\" disabled selected>" + pedido(nome) + "</option>" +
          vals.map(function (v) { return "<option>" + v + "</option>"; }).join("") +
          "</select></label>";
      }).join("");
      /* Nada fica pre-escolhido: a marca do carro tem de ser uma escolha
         explicita, senao o cliente carrega em Add e leva a primeira da lista. */
      escolhido.sel = escolhido.opcoes.map(function () { return null; });
      /* Se o painel foi reconstruido por um redesenhar(), devolver as opcoes
         que o cliente ja tinha escolhido em vez de o obrigar a comecar outra vez. */
      if (selAnterior) {
        caixa.querySelectorAll("[data-sar-opt]").forEach(function (s, i) {
          if (!selAnterior[i]) return;
          s.value = selAnterior[i];
          if (s.value === selAnterior[i]) escolhido.sel[i] = selAnterior[i];
        });
      }
      painel.hidden = false;
      assentarPicker(painel);
      atualizarPicker();
      if (botao) botao.disabled = false;
    }).catch(function () { if (botao) botao.disabled = false; });
  }

  function varianteEscolhida() {
    if (!escolhido) return null;
    for (var i = 0; i < escolhido.prod.variants.length; i++) {
      var v = escolhido.prod.variants[i], bate = true;
      for (var j = 0; j < escolhido.sel.length; j++) {
        if (v.options[j] !== escolhido.sel[j]) { bate = false; break; }
      }
      if (bate) return v;
    }
    return null;
  }

  function atualizarPicker() {
    var painel = gaveta.querySelector("[data-sar-picker]");
    var bt = painel.querySelector("[data-sar-picker-add]");
    var v = varianteEscolhida();
    if (v && v.available) {
      bt.disabled = false;
      bt.textContent = "Add " + dinheiro(v.price);
      bt.setAttribute("data-id", v.id);
      precoPicker(painel, v.price, v.compare_at_price);
    } else {
      bt.disabled = true;
      bt.removeAttribute("data-id");
      /* Dizer qual a opcao que falta, em vez de um "Unavailable" mudo. */
      var falta = null;
      for (var k = 0; k < escolhido.sel.length; k++) {
        if (!escolhido.sel[k]) { falta = escolhido.opcoes[k]; break; }
      }
      bt.textContent = falta ? (pedido(falta) + " first") : (v ? "Sold out" : "Unavailable");
      precoPicker(painel, escolhido.prod.price, escolhido.prod.compare_at_price);
    }
  }

  /* Preco da linha pendente. Comeca no preco base do produto e passa ao da
     variante assim que ela esta escolhida. */
  function precoPicker(painel, centimos, comparar) {
    var alvo = painel.querySelector("[data-sar-picker-preco]");
    if (!alvo) return;
    var html = dinheiro(centimos);
    if (comparar && comparar > centimos) html += "<s>" + dinheiro(comparar) + "</s>";
    alvo.innerHTML = html;
  }

  /* A linha pendente entra no topo do carrinho. Se a gaveta ja tiver produtos
     e estiver rolada para baixo, subir para o cliente a ver — antes o painel
     flutuava e no telemovel tapava o carrossel de sugestoes. */
  function assentarPicker(painel) {
    painel.style.bottom = "";
    gaveta.classList.add("com-pendente");
    try {
      [".sar-gaveta__corpo", ".sar-meio"].forEach(function (sel) {
        var c = gaveta.querySelector(sel);
        if (c && c.scrollHeight > c.clientHeight) c.scrollTop = 0;
      });
    } catch (e) {}
  }

  function fecharPicker() {
    var painel = gaveta.querySelector("[data-sar-picker]");
    if (painel) { painel.hidden = true; painel.style.bottom = ""; }
    gaveta.classList.remove("com-pendente");
    escolhido = null;
    pickerAberto = null;
  }

  /* ---------- ligacao ---------- */
  function ligar() {
    if (!montar()) return;

    /* fase de CAPTURA: corre antes dos handlers do tema (cart-drawer.js
       continua carregado e disputava o clique no icone do carrinho) */
    document.addEventListener("click", function (e) {
      if (e.target.closest(".sar-gaveta__fechar") || e.target.classList.contains("sar-veu")) {
        e.preventDefault(); fechar(); return;
      }
      var saco = e.target.closest('a[href$="/cart"], a[href*="/cart?"], #cart-icon-bubble, .header__icon--cart');
      if (saco && !e.target.closest(".sar-gaveta")) {
        e.preventDefault();
        gaveta.classList.add("a-trabalhar");
        abrir();
        redesenhar().finally(function () { gaveta.classList.remove("a-trabalhar"); });
        return;
      }
      var b = e.target.closest("[data-sar-qtd]");
      if (b) {
        e.preventDefault();
        var linha = b.closest(".sar-linha"); if (!linha) return;
        var chave = linha.getAttribute("data-chave");
        var n = parseInt(linha.querySelector(".sar-passo__n").textContent.trim(), 10) || 1;
        var acao = b.getAttribute("data-sar-qtd");
        if (acao === "tirar") return mudar(chave, 0);
        if (acao === "menos") return mudar(chave, Math.max(0, n - 1));
        if (acao === "mais") return mudar(chave, n + 1);
      }
      var j = e.target.closest("button[data-sar-juntar]");
      if (j) { e.preventDefault(); juntar(j.getAttribute("data-sar-juntar"), j); return; }
      var esc = e.target.closest("button[data-sar-escolher]");
      if (esc) { e.preventDefault(); abrirPicker(esc.getAttribute("data-sar-escolher"), esc); return; }
      if (e.target.closest("[data-sar-picker-fechar]")) { e.preventDefault(); fecharPicker(); return; }
      var addv = e.target.closest("[data-sar-picker-add]");
      if (addv && addv.getAttribute("data-id")) {
        e.preventDefault();
        var id = addv.getAttribute("data-id");
        fecharPicker();
        juntar(id, addv);
      }
    }, true);

    document.addEventListener("change", function (e) {
      var c = e.target.closest("[data-sar-seguro]");
      if (c) { seguro(c); return; }
      var opt = e.target.closest("[data-sar-opt]");
      if (opt && escolhido) {
        escolhido.sel[parseInt(opt.getAttribute("data-sar-opt"), 10)] = opt.value;
        atualizarPicker();
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && gaveta.classList.contains("aberta")) fechar();
    });

    /* Dawn / FullStack: qualquer POST a /cart/* reabre e redesenha */
    var fetchOriginal = window.fetch;
    window.fetch = function () {
      var url = arguments[0] && (arguments[0].url || arguments[0]);
      var r = fetchOriginal.apply(this, arguments);
      if (typeof url === "string" && /\/cart\/(add|change|update)/.test(url) && url.indexOf("sections=") === -1) {
        /* SO as adicoes abrem a gaveta. Apps da loja (pixel do Facebook,
           entre outras) escrevem atributos com /cart/update.js ao carregar
           a pagina; abrir a gaveta nesses casos fazia-a aparecer sozinha
           a direita mesmo com o carrinho vazio. */
        var ehAdicao = /\/cart\/add/.test(url);
        r.then(function () {
          if (ehAdicao) { gaveta.classList.add("a-trabalhar"); abrir(); }
          redesenhar().finally(function () { gaveta.classList.remove("a-trabalhar"); });
        }).catch(function () {});
      }
      return r;
    };

    pintar();
    cronometro();

    /* Intercetar o formulario de produto.
       O product-form.js do tema faz:
         this.cart = querySelector("cart-notification") || querySelector("cart-drawer")
       Como removemos ambos, this.cart fica null, o tema deixa de intercetar,
       e o formulario submete-se nativamente -> o browser navega para /cart.
       Apanhamos o submit na fase de captura e tratamos nos aqui. */
    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (!form || form.tagName !== "FORM") return;
      var action = form.getAttribute("action") || "";
      if (action.indexOf("/cart/add") === -1) return;
      e.preventDefault();
      e.stopPropagation();
      var bt = form.querySelector('[type="submit"]');
      if (bt) bt.classList.add("loading");
      fetch("/cart/add.js", {
        method: "POST",
        body: new FormData(form),
        headers: { "X-Requested-With": "XMLHttpRequest" }
      })
        .then(function (r) { return r.json(); })
        .then(function () { abrir(); return redesenhar(); })
        .catch(function (err) { console.error("sar-gaveta:", err); })
        .finally(function () { if (bt) bt.classList.remove("loading"); });
    }, true);

    /* Os formularios do Shopify (mudar de pais/moeda) guardam o URL de
       chegada em return_to. Se o cliente veio de um email com ?escolher= ou
       ?carrinho=1, mudar de pais voltava a esse URL e reabria a gaveta com o
       produto do email. Limpamos esses parametros em todos os return_to. */
    try {
      Array.prototype.forEach.call(document.querySelectorAll('input[name="return_to"]'), function (inp) {
        var v = inp.value || "";
        var nv = v.replace(/([?&])(escolher=[a-z0-9-]+|carrinho=1)(&|$)/ig, "$1").replace(/([?&])(escolher=[a-z0-9-]+|carrinho=1)(&|$)/ig, "$1").replace(/[?&]+$/, "").replace("?&", "?");
        if (nv !== v) inp.value = nv || "/";
      });
    } catch (e) {}

    /* Vem de um email com ?escolher=<handle>: abre a gaveta e o seletor de
       variantes desse produto, para o cliente escolher a marca do carro sem
       ter de ir a pagina do produto. */
    var mEsc = window.location.search.match(/[?&]escolher=([a-z0-9-]+)/i);
    if (mEsc) {
      abrir();
      abrirPicker(mEsc[1], null);
      redesenhar();
      try {
        var limpoE = window.location.pathname +
          window.location.search.replace(/([?&])escolher=[a-z0-9-]+(&|$)/i, "$1").replace(/[?&]$/, "");
        window.history.replaceState({}, "", limpoE);
      } catch (e) {}
    }

    /* Chegou da pagina /cart (redirecionada pela seccao): abre a gaveta e
       limpa o parametro do URL para nao ficar no historico. */
    if (/[?&]carrinho=1(&|$)/.test(window.location.search)) {
      abrir();
      redesenhar();
      try {
        var limpo = window.location.pathname +
          window.location.search.replace(/([?&])carrinho=1(&|$)/, "$1").replace(/[?&]$/, "");
        window.history.replaceState({}, "", limpo);
      } catch (e) {}
    }

    /* Rede de seguranca: se o cliente aterrar na pagina /cart (por um link
       que escapou, ou por navegacao direta), abre a gaveta por cima em vez
       de o deixar com o carrinho antigo do tema. */
    if (/^\/cart\/?$/.test(window.location.pathname)) {
      abrir();
      redesenhar();
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", ligar);
  else ligar();
})();
